import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { GlobalsService } from 'src/app/services/globals.service';

@Component({
  selector: 'app-bcrumbsnav',
  templateUrl: './bcrumbsnav.component.html',
  styleUrls: ['./bcrumbsnav.component.less']
})
export class BcrumbsnavComponent implements OnInit {
  page: string = "";
  pageId: number = 0;
  isPageDisclaimer: boolean = false;
  breadcrumbList: Array<BreadcrumbItem> = []
  studentType: number = 0;

  constructor(private data: DataService,
    private globals: GlobalsService) { }

  ngOnInit() {
    //NB: Order of items is important
    let crumb1: BreadcrumbItem = { id: 1, name: "home" }
    let crumb2: BreadcrumbItem = { id: 2, name: "disclaimer" }
    let crumb3: BreadcrumbItem = { id: 3, name: "programme" }
    let crumb4: BreadcrumbItem = { id: 4, name: "modules" }
    let crumb5: BreadcrumbItem = { id: 5, name: "summary" }
    let crumb6: BreadcrumbItem = { id: 6, name: "personalinfo" }
    let crumb7: BreadcrumbItem = { id: 7, name: "report" }

    this.breadcrumbList.push(crumb1, crumb2, crumb3, crumb4, crumb5 ,crumb6, crumb7);

    this.updateCurrentPage();
  }

  public updateCurrentPage() {
    //First get current page from DataService and set PageId
    this.data.currentPage.subscribe(currentPage => {
      this.page = currentPage;
      var currentBreadcrumb = this.breadcrumbList.find(b => b.name == currentPage);
      if(currentBreadcrumb){
        this.pageId = currentBreadcrumb.id;
      }
      else this.pageId = 0;

      //isPageDisclaimer is used to show/hide print button
      if(this.page && this.page == "disclaimer") {
        this.isPageDisclaimer = true;

        if(this.globals.quotationDetail){
          this.studentType = this.globals.quotationDetail.studentType;
        }
      }
      else {
        this.isPageDisclaimer = false;
      }
      
      this.breadcrumbList.forEach(item => {
        var linkItem = document.getElementById(item.name);
        if(linkItem){
          linkItem.classList.remove("current");
          linkItem.classList.remove("disabled");
          //TODO: Remove disabled style from link item
          var breadcrumbItem = this.breadcrumbList.find(b => b.name == item.name);
          if(breadcrumbItem && breadcrumbItem.id > this.pageId){
            linkItem.classList.add("disabled");
          }
        }
      });

      var currentLink = document.getElementById(this.page);
      if(currentLink){
        currentLink.classList.add("current");
      }
    });
  }

  printDisclaimer(){
   var contents = document.getElementById("local-section").innerHTML;
   if(this.studentType != 1) {
     contents = document.getElementById("oversees-section").innerHTML;
   }

   var frame1 = document.createElement('iframe');
   frame1.name = "frame1";
   frame1.style.position = "absolute";
   frame1.style.top = "-1000000px";
   document.body.appendChild(frame1);
   var frameDoc = frame1.contentWindow;
   frameDoc.document.open();
   frameDoc.document.write('<html><head><title></title>');
   frameDoc.document.write('</head><body>');
   frameDoc.document.write(contents);
   frameDoc.document.write('</body></html>');
   frameDoc.document.close();
   setTimeout(function () {
       window.frames["frame1"].focus();
       window.frames["frame1"].print();
       document.body.removeChild(frame1);
   }, 200);
  }
}

export class BreadcrumbItem {
  id: number;
  name: string;
}
